export const account = {
    login: {
        loading: 'Loading...',
        title: 'Sign In',
        incorrectCredentials: 'Incorrect username or password.',
        usernameLabel: 'Username or email',
        passwordLabel: 'Password',
        submitButton: 'Sign In',
        noAccount: "Don't have an account?",
        createOne: 'Create one',
    },
    register: {
        title: 'Create Account',
        subtitle: 'Create an account to purchase and manage your tickets.',
        passwordMismatch: 'Passwords do not match.',
        passwordTooShort: 'Password must be at least 8 characters.',
        registrationFailed: 'Registration failed. Please try again.',
        firstNameLabel: 'First name',
        lastNameLabel: 'Last name',
        emailLabel: 'Email address',
        passwordLabel: 'Password',
        confirmPasswordLabel: 'Confirm password',
        submitButton: 'Create Account & Continue',
        haveAccount: 'Already have an account?',
        signIn: 'Sign in',
    },
    myTickets: {
        loading: 'Loading your tickets...',
        loadErrorTitle: 'Could not load tickets',
        loadErrorBody: 'Please try again later.',
        cancelFailed: 'Failed to cancel order. Please try again.',
        statusConfirmed: 'Confirmed',
        statusPending: 'Pending',
        statusCancelled: 'Cancelled',
        statusRefunded: 'Refunded',
        refundProcessed: 'Refund processed',
        bookingCancelled: 'Booking cancelled',
        addToCalendarTitle: 'Add to Calendar',
        cancelButton: 'Cancel',
        title: 'My Tickets',
        emptyTitle: 'No tickets yet',
        emptySubtitle: 'Ready to find your next course?',
        browseEvents: 'Browse Courses',
        upcoming: 'Upcoming',
        pastEvents: 'Past Courses',
        cancelBookingHeader: 'Cancel booking',
        cancelBookingContent: 'Are you sure you want to cancel order {orderRef}? This cannot be undone.',
        confirmCancel: 'Yes, cancel booking',
        keepBooking: 'Keep booking',
        ticketCountSingular: '{quantity} ticket',
        ticketCountPlural: '{quantity} tickets',
    },
    ticketDetail: {
        loading: 'Loading ticket...',
        notFoundTitle: 'Ticket not found',
        backToMyTickets: 'Back to My Tickets',
        tapToClose: 'Tap anywhere to close',
        myTicketsLink: 'My Tickets',
        addToCalendar: 'Add to Calendar',
        transfer: 'Transfer',
        transferTitle: 'Transfer tickets to someone else',
        cancelSuccessMessage: 'Your booking has been cancelled.',
        cancelFailedMessage: 'Failed to cancel. Please try again.',
        refundNote: 'Any refund will be returned to your original payment method within 5–10 business days.',
        statusConfirmed: 'Confirmed',
        statusPending: 'Pending',
        statusCancelled: 'Cancelled',
        statusRefunded: 'Refunded',
        orderReference: 'Order reference',
        ticketsLabel: 'Tickets',
        ticketCountSingular: '{quantity} ticket',
        ticketCountPlural: '{quantity} tickets',
        purchased: 'Purchased',
        cancelBooking: 'Cancel this booking',
        refundReturnedNote: 'Refund returned to your original payment method.',
        yourTickets: 'Your Tickets',
        tapToEnlargeHint: 'Tap a QR code to enlarge it for scanning at the door.',
        ticketOfTotal: 'Ticket {index} of {total}',
        usedAt: 'Used {date}',
        tapToEnlarge: 'Tap to enlarge',
        beforeEvent: 'Before the course',
        eventResources: 'Course resources',
        spreadTheWord: 'Spread the word',
        shareDescription: "Share your personal link — we'll track who you've brought along.",
        linkCopied: 'Link copied to clipboard!',
        shareThisEvent: 'Share this course',
        shareEventButton: 'Share course',
        shareText: "I'm going to {eventName}! Get your tickets here:",
        cancelBookingHeader: 'Cancel booking',
        cancelBookingConfirmContent: 'Are you sure you want to cancel this booking? This cannot be undone.',
        confirmCancel: 'Yes, cancel booking',
        keepBooking: 'Keep booking',
    },
    transfer: {
        loading: 'Loading order...',
        orderNotFoundTitle: 'Order not found',
        orderNotFoundBody: "This order doesn't exist or cannot be transferred.",
        backToMyTickets: 'Back to My Tickets',
        initiatedTitle: 'Transfer initiated',
        initiatedBody: "We've sent a transfer link to {email}. They have 7 days to accept. You'll keep the tickets until they do.",
        backToTicket: 'Back to ticket',
        title: 'Transfer Ticket',
        orderSummarySingular: 'Order {orderRef} · {quantity} ticket',
        orderSummaryPlural: 'Order {orderRef} · {quantity} tickets',
        instructions: "Enter the email address of the person you'd like to transfer your tickets to. They'll receive an email with a link to accept. Your tickets remain valid until they do.",
        recipientEmailRequired: "Please enter the recipient's email address.",
        invalidEmail: 'Please enter a valid email address.',
        emailMismatch: 'Email addresses do not match.',
        recipientEmailLabel: "Recipient's email address",
        confirmEmailLabel: 'Confirm email address',
        emailPlaceholder: 'their@email.com',
        confirmEmailPlaceholder: 'their@email.com again',
        sendButton: 'Send transfer link',
        cancelButton: 'Cancel',
    },
    acceptTransfer: {
        loading: 'Loading transfer...',
        notFoundTitle: 'Transfer not found',
        notFoundBody: 'This transfer link is invalid or has already been used.',
        browseEvents: 'Browse courses',
        expiredTitle: 'Transfer link expired',
        expiredBody: 'This transfer link has expired. Please ask the sender to initiate a new transfer.',
        alreadyAcceptedTitle: 'Already accepted',
        alreadyAcceptedBody: 'This transfer has already been accepted.',
        viewMyTickets: 'View My Tickets',
        cancelledTitle: 'Transfer cancelled',
        cancelledBody: 'This transfer has been cancelled by the sender.',
        successTitle: 'Tickets transferred!',
        successBody: 'The tickets for {eventName} are now in your account.',
        viewMyTicketsButton: 'View my tickets',
        title: 'Accept Ticket Transfer',
        orderSummarySingular: 'Order {orderRef} · {quantity} ticket',
        orderSummaryPlural: 'Order {orderRef} · {quantity} tickets',
        sentTo: 'Sent to: {email}',
        wrongAccountTitle: 'Wrong account',
        wrongAccountBody: "You're logged in as {currentEmail}, but this transfer was sent to {recipientEmail}. Please log out and sign in with the correct account.",
        acceptInstructions: 'Click below to accept these tickets and add them to your account.',
        acceptButton: 'Accept transfer',
    },
    profile: {
        loading: 'Loading profile...',
        title: 'My Profile',
        profileUpdated: 'Profile updated.',
        profileUpdateFailed: 'Failed to update profile.',
        avatarUpdated: 'Avatar updated.',
        avatarUploadFailed: 'Failed to upload avatar. Use a JPG, PNG or WebP under 5 MB.',
        passwordChanged: 'Password changed.',
        currentPasswordIncorrect: 'Current password incorrect.',
        passwordChangeFailed: 'Failed to change password.',
        newPasswordMismatch: 'New passwords do not match.',
        passwordTooShort: 'Password must be at least 8 characters.',
        photoSectionTitle: 'Profile Photo',
        uploading: 'Uploading…',
        uploadPhoto: 'Upload photo',
        photoHint: 'JPG, PNG or WebP. Displayed on course attendee lists.',
        personalDetailsTitle: 'Personal Details',
        firstNameLabel: 'First name',
        lastNameLabel: 'Last name',
        phoneLabel: 'Phone',
        phonePlaceholder: '+44 7700 900000',
        bioLabel: 'Bio',
        bioPlaceholder: 'Tell other attendees a bit about yourself…',
        socialLinks: 'Social Links',
        websiteLabel: 'Website',
        websitePlaceholder: 'https://yourwebsite.com',
        twitterLabel: 'Twitter / X handle',
        twitterPlaceholder: 'yourhandle (without @)',
        linkedinLabel: 'LinkedIn URL',
        linkedinPlaceholder: 'https://linkedin.com/in/you',
        privacy: 'Privacy',
        showOnAttendeeLists: 'Show me on course attendee lists',
        attendeeListsDescription: 'When enabled, your name and profile appear on course pages where the organiser has turned on the attendee list. You can change this at any time.',
        saveChanges: 'Save Changes',
        changePasswordTitle: 'Change Password',
        currentPasswordLabel: 'Current password',
        newPasswordLabel: 'New password',
        confirmNewPasswordLabel: 'Confirm new password',
        changePasswordButton: 'Change Password',
    },
    memberships: {
        loading: 'Loading memberships...',
        title: 'Memberships',
        hasMemberships: 'Here are your current memberships.',
        noMemberships: "You don't have any memberships yet.",
        loadErrorTitle: 'Could not load memberships',
        loadError: 'Please refresh the page and try again.',
        yourMemberships: 'Your Memberships',
        colName: 'Name',
        colStartDate: 'Start date',
        colEndDate: 'Renews / ends',
        colCost: 'Cost',
        colStatus: 'Status',
        recurring: 'Recurring',
        free: 'Free',
        active: 'Active',
        activeUntil: 'Active until {date}',
        undoCancellation: 'Undo cancellation',
        cancelMembership: 'Cancel',
        availablePlans: 'Available Plans',
        creditsPerMonth: '{count} credits per month',
        creditPerMonth: '{count} credit per month',
        selectButton: 'Select',
        noPlansAvailable: 'No membership plans are available right now.',
        confirmCancelTitle: 'Cancel this membership?',
        confirmCancelFree: 'Are you sure you want to cancel this membership? This cannot be undone.',
        confirmCancelPaid: 'Your membership will stay active until {date}, then it will not renew. You can undo this at any time before then.',
        keepButton: 'Keep membership',
        confirmButton: 'Yes, cancel',
        cancelButton: 'Cancel',
        subscribeTitle: 'Subscribe to {name}',
        preparingPayment: 'Preparing payment...',
        paymentError: 'Payment error',
        paymentInitError: 'Could not set up payment. Please try again.',
        subscriptionActivated: 'Subscription activated',
        subscriptionSuccess: 'Your membership is now active.',
        doneButton: 'Done',
        subscribeButton: 'Subscribe',
        paymentFailed: 'Payment failed',
        subscribeFailed: 'Subscription could not be created. Please check your card details and try again.',
        cancelError: 'Failed to cancel membership. Please try again.',
        reactivateError: 'Failed to reactivate membership. Please try again.',
    },
    protectedRoute: {},
};
